module.exports = __webpack_public_path__ + "static/scale-model-of-olbrich-botanical-gardens-in-madison-wisconsin-2118b93ccb11979fb0cc3677375d747e.png";